// DMK — turn the footer localization into a compact dropdown
(function() {
  function findFooterForm() {
    var footers = document.querySelectorAll('footer');
    for (var i = 0; i < footers.length; i++) {
      var f = footers[i].querySelector('localization-form-component');
      if (f) return f;
    }
    return null;
  }

  function currentCurrency() {
    // Look for currently selected list item
    var current = document.querySelector('.localization-form__list-item[aria-current="true"] .localization-form__currency');
    if (current) return current.textContent.trim().replace(/\s+/g, ' ');
    return 'USD $';
  }

  function build() {
    var form = findFooterForm();
    if (!form) return;
    if (form.dataset.dmkWrapped === '1') return;

    // Insert a wrapper with a trigger + collapsible panel
    var wrap = document.createElement('div');
    wrap.className = 'dmk-currency-dropdown';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dmk-currency-trigger';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="dmk-currency-code">' + currentCurrency() + '</span><span class="dmk-currency-caret" aria-hidden="true">▾</span>';

    var panel = document.createElement('div');
    panel.className = 'dmk-currency-panel';
    panel.setAttribute('hidden', '');

    // Move the form INTO the panel
    form.parentNode.insertBefore(wrap, form);
    panel.appendChild(form);
    wrap.appendChild(btn);
    wrap.appendChild(panel);

    form.dataset.dmkWrapped = '1';

    // Toggle
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var isOpen = btn.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('hidden', '');
      } else {
        btn.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
      }
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (!wrap.contains(e.target)) {
        btn.setAttribute('aria-expanded', 'false');
        panel.setAttribute('hidden', '');
      }
    });

    // Close after selecting a currency
    panel.addEventListener('click', function(e) {
      var item = e.target.closest('.localization-form__list-item');
      if (item) {
        setTimeout(function() {
          btn.querySelector('.dmk-currency-code').textContent = currentCurrency();
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', '');
        }, 50);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  var mo = new MutationObserver(function() { build(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();
